import { jsx } from 'react/jsx-runtime';
import { FacebookFilled, YoutubeFilled, TiktokFilled, InstagramFilled, ZaloFilled } from '@teko-builder/icons';
import React from 'react';
import './InputNumber-7d93e963.js';
import { Link } from './components/shared/Link.es.js';
import 'tslib';
import 'rc-select';
import './FormItem-098fa619.js';
import { getStyle } from './utils.es.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';
import styled from '@emotion/styled';

const socialIconMapping = {
    facebook: {
        icon: FacebookFilled,
        color: '#415993',
    },
    youtube: {
        icon: YoutubeFilled,
        color: '#bd342b',
    },
    tiktok: {
        icon: TiktokFilled,
        color: '#262626',
    },
    instagram: {
        icon: InstagramFilled,
        color: '#d96357',
    },
    zalo: { icon: ZaloFilled, color: '#2d75f6' },
};
const SocialIcon = ({ commonStyle, icons, iconSize, iconStyle, }) => {
    return (jsx(Wrapper, Object.assign({ commonStyle: commonStyle }, { children: icons.map((e, index) => (jsx(Link, Object.assign({}, e.link, { children: jsx(IconWrapper, Object.assign({ iconStyle: Object.assign(Object.assign({}, iconStyle), { height: iconStyle.width, backgroundColor: socialIconMapping[e.name].color }) }, { children: React.createElement(socialIconMapping[e.name].icon, {
                    style: {
                        fontSize: iconSize || 25,
                    },
                }) })) }), index))) })));
};
const Wrapper = styled.div(({ commonStyle }) => `
  ${getStyle(commonStyle)};
  display: flex;
`);
const IconWrapper = styled.div(({ iconStyle }) => `
${getStyle(iconStyle)};
display: flex;
align-items: center;
justify-content: center;
border-radius: 10%;
& svg {
  color: white;
  line-height: 1; 
}
`);
SocialIcon.displayName = 'SocialIcon';

export { SocialIcon as S };
